module.exports = {"pathContext":{"title":"My Lisp Experiences and the Development of GNU Emacs (2002)","createdAt":"20 hours ago","by":"tosh","comments":[{"text":"One of the previous discussions on this topic.<p><a href=\"https:&#x2F;&#x2F;news.ycombinator.com&#x2F;item?id=8433945\" rel=\"nofollow\">https:&#x2F;&#x2F;news.ycombinator.com&#x2F;item?id=8433945</a>","by":"mbrumlow","timeISO":"14 hours ago"}]}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/comment-17767225.json
// module id = 869
// module chunks = 254844527311522